import React from "react";
import TermsAndConditionsHero from "../components/termsAndConditionsPage/TermsAndConditionsHero";

 
import Navbar from "../components/homepage/Navbar";
import TermsAndConditionsDetails from "../components/termsAndConditionsPage/TermsAndConditionsDetails";
import { Header, Footer } from "../shared";

const TermsAndConditionsPage = () => {
  window.scrollTo(0, 0);
  return (
    <div className="BuyCertifiedDrone_backgorund">
      <div className="bg_darkblue">
        <Header />
      </div>
      <TermsAndConditionsHero />
      <TermsAndConditionsDetails />
      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;
